import { render, staticRenderFns } from "./serial-no-report.vue?vue&type=template&id=0f66f369&"
import script from "./serial-no-report.vue?vue&type=script&lang=ts&"
export * from "./serial-no-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports